$('body').on('click', '.show-freebie', function() {
    var $this = $(this);
    $this.parents('.freebie-wrapper').addClass('showing');
    
    return false;
});

$('body').on('click', '.select-package-trigger', function () {
    var $this = $(this);
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            '_method': 'PUT'
        },
        dataType: 'json',
        success: function (data) {
            if (!data.success) {
                showNotice('Error', data.message, 'Close');
                return false;
            }
            
            if (data.cart) {
                updateCart(data.cart);
            }

            return false;
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});







function addOrders(data) {
    // add new orders
    $.each(data.orders, function (index, order) {
        if ($('.team-donors .order[data-order="' + order.order + '"]').length) {
            return true;
        }


        $('.team-donors .inner-wrapper').append(`<div class="order" data-order="${order.order}">
            <div class="order-details">
                <img src="images/user.svg" alt="user">
                <div class="amount">${order.amount}</div>
                <div class="name">${order.amount}</div>
            </div>
        </div>`);
    });

    // update the load more button
    $('.load-more-donors-wrapper').addClass('hidden');
    if (data.pagination['next-pages'].length) {
        $('.load-more-donors-wrapper').removeClass('hidden');
        // update the load more button
        $('.load-more-donors').attr('data-page', data.pagination['next-pages'][0]);
    }
}
$('body').on('click', '.load-more-donors', function () {
    var $this = $(this);
    closeDropdown();

    $this.addClass('is-loading');

    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: $this.attr('data-page')
        },
        dataType: 'json',
        success: function (data) {
            $this.removeClass('is-loading');

            if(data.results) {
                addOrders(data.results);
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});